import Layout1 from "@/layout/Layout1";

export default [
  {
    path: "/escuela-observadores-democraticos/modulos",
    component: Layout1,
    children: [
      {
        path: "",
        redirect: "/escuela-observadores-democraticos/modulos/list"
      },
      {
        path: "list",
        name: "escuela-observadores-democraticos-modulos-list",
        component: () => import("@/views/volunteering/ListVoluntariadoEodModulos"),
        meta: {
          title: "Módulos EOD - Lista",
          requiresAuth: true
        }
      },
      {
        path: "add",
        name: "escuela-observadores-democraticos-modulos-add",
        component: () => import("@/views/volunteering/AddEditVoluntariadoEodModulo"),
        meta: {
          title: "Módulos EOD - Agregar",
          requiresAuth: true
        }
      },
      {
        path: "edit/:id",
        name: "escuela-observadores-democraticos-modulos-edit",
        component: () => import("@/views/volunteering/AddEditVoluntariadoEodModulo"),
        meta: {
          title: "Módulos EOD - Editar",
          requiresAuth: true
        }
      },
      {
        path: "detail/:id",
        name: "escuela-observadores-democraticos-modulos-detail",
        component: () => import("@/views/volunteering/VoluntariadoEodModuloDetail"),
        meta: {
          title: "Módulos EOD - Detalle",
          requiresAuth: true
        }
      }
    ]
  }
];
